import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "ddrmsDocuments",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    generatedContract: null,
    repoUploadStatus: false,
    repoUploadDocId: null,
  },
  reducers: {
    repositoryDocumentsReceived: (ddrmsDocuments, action) => {
      ddrmsDocuments.list = action.payload;
      ddrmsDocuments.repoUploadStatus = false;
    },
    generatedContractReceived: (ddrmsDocuments, action) => {
      ddrmsDocuments.generatedContract = action.payload;
    },
    ddrmsRepoDocumentUploaded: (ddrmsDocuments, action) => {
      const { status } = action.payload;
      ddrmsDocuments.repoUploadStatus = status;
    },
    ddrmsRepoReqDocUploaded: (ddrmsDocuments, action) => {
      const { docId } = action.payload;
      ddrmsDocuments.repoUploadDocId = docId;
    },
  },
});

export const {
  repositoryDocumentsReceived,
  generatedContractReceived,
  ddrmsRepoDocumentUploaded,
  ddrmsRepoReqDocUploaded,
} = slice.actions;
export default slice.reducer;

export const loadDdrmsRepositoryDocs = (id) =>
  apiCallBegan({
    url: config.GetDdrmsRepository + id,
    onSuccess: repositoryDocumentsReceived.type,
  });

export const loadGenerateContractDocument1 = (ciid, id) =>
  apiCallBegan({
    url: config.GenerateContractDoc + ciid + "&docId=" + id,
    responseType: "blob",
    onSuccess: generatedContractReceived.type,
  });

export const UploadDdrmsRepositoryDocs = (data) =>
  apiCallBegan({
    url: config.UploadRepositoryDocument,
    method: "post",
    data: data,
    onSuccess: ddrmsRepoDocumentUploaded.type,
  });

export const UploadDdrmsReqRepositoryDocs = (data) =>
  apiCallBegan({
    url: config.UploadRepositoryDocument,
    method: "post",
    data: data,
    onSuccess: ddrmsRepoReqDocUploaded.type,
  });

export const loadGenerateContractDocument = (data) =>
  apiCallBegan({
    url: config.GenerateContractDoc,
    method: "post",
    data: data,
    responseType: "blob",
    onSuccess: generatedContractReceived.type,
  });

export const getDdrmsRepositoryDocuments = createSelector(
  (state) => state.entities.ddrmsDocuments,
  (ddrmsDocuments) => ddrmsDocuments.list,
);

export const getGeneratedDocument = createSelector(
  (state) => state.entities.ddrmsDocuments,
  (ddrmsDocuments) => ddrmsDocuments.generatedContract,
);

export const getDdrmsRepoUploadStatus = createSelector(
  (state) => state.entities.ddrmsDocuments,
  (ddrmsDocuments) => ddrmsDocuments.repoUploadStatus,
);

export const getDdrmsRepoUploadedDocId = createSelector(
  (state) => state.entities.ddrmsDocuments,
  (ddrmsDocuments) => ddrmsDocuments.repoUploadDocId,
);
